import TreeDataGrid from "./TreeDataGrid";

export default function APLDataGrid({
  period,
  data,
  columns: rawColumns,
  columnExtensions,
}) {
  const totalHours = period
    ? Math.round(
        ((new Date(period.to) - new Date(period.from)) /
          (7 * 24 * 60 * 60 * 1000)) *
          period.hoursPerWeek
      )
    : 0;

  const columns = rawColumns.map((col) => {
    const ext = columnExtensions?.find((e) => e.columnName === col.name);
    return {
      id: col.name,
      key: col.name,
      header: col.title,
      width: ext?.width ?? 150,
      sortable: !["name", "edit"].includes(col.name),
    };
  });

  const getRowStyle = (row) => {
    if (!totalHours || !row.original.hours) return undefined;
    const rowColorAmount = (row.original.hours / totalHours) * 100;
    return {
      background: `linear-gradient(to right, #90EE90 ${rowColorAmount}%, #E4E4E4 ${rowColorAmount}%)`,
    };
  };

  return (
    <TreeDataGrid
      rows={data}
      columns={columns}
      treeColumnId="name"
      rowStyle={getRowStyle}
    />
  );
}
